import React from 'react';
import ModuleRoute from 'holocron-module-route';
import { Route } from '@americanexpress/one-app-router';

export const EmptyBody = () => null;

const childRoutes = () => [
  <Route key="/3ds/v1" exact={true} path="/3ds/v1" component={EmptyBody} />,
  <Route key="/3ds/v2" exact={true} path="/3ds/v2" component={EmptyBody} />,
  <ModuleRoute key="/" path="/" moduleName="axp-gravity-page-wrapper">
    <ModuleRoute path="/express" title="express" moduleName="axp-gravity-express" />
    <ModuleRoute path="/rewards" title="rewards" moduleName="axp-gravity-rewards" />
    <ModuleRoute path="/otc" title="oneTime" moduleName="axp-gravity-one-time-code" />
    <ModuleRoute path="/push" title="push" moduleName="axp-gravity-push-notification-status" />
    <ModuleRoute path="/manageExpress" title="expressList" moduleName="axp-gravity-manage-express-list" />
    <ModuleRoute path="/red" title="static" moduleName="axp-gravity-static-message" />
    <ModuleRoute path="/ncd" title="userVerification" moduleName="axp-gravity-user-verification" />
    <ModuleRoute path="/ucd" title="ucd" moduleName="axp-gravity-update-contact-information" />
    <ModuleRoute path="/csc" title="csc" moduleName="axp-gravity-card-security-value" />
    <ModuleRoute path="/pin" title="pin" moduleName="axp-gravity-partial-pin" />
    <ModuleRoute path="/emi" title="emi" moduleName="axp-gravity-installment-options" />
    <ModuleRoute path="/authn" title="webAuthN" moduleName="axp-gravity-web-authenticate" />
  </ModuleRoute>,
];

export default childRoutes;
